var _style, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConseil1PageParcoursupCoach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,16c-1.9,0-3.5-1.6-3.5-3.5c0,0,0,0,0,0V4.7c0-1.9,1.6-3.5,3.5-3.5c0,0,0,0,0.1,0h7.7 c1.9,0,3.5,1.6,3.5,3.5c0,0,0,0,0,0v7.8c0,1.9-1.6,3.5-3.5,3.5c0,0,0,0,0,0H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 47.435,
    x2: 15.62,
    y2: 47.435,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.8,0.8c-0.4-0.1-0.8-0.2-1.1-0.2H4c-2.2,0-4,1.8-4,4v7.8c0,2.2,1.8,4,4,4h7.7c2.2,0,4-1.8,3.9-4V4.7 C15.7,2.9,14.5,1.3,12.8,0.8z M14.7,12.5c0,1.7-1.3,3-3,3.1H4c-1.7,0-3-1.4-3-3.1V4.7c0-1.7,1.3-3,3-3.1h7.7c0.1,0,0.3,0,0.4,0 c1.5,0.2,2.6,1.5,2.6,3L14.7,12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,35.3c-1.9,0-3.5-1.5-3.5-3.5c0,0,0,0,0-0.1v-7.8C0.5,22,2,20.4,4,20.4c0,0,0,0,0,0h7.7 c1.9,0,3.5,1.6,3.5,3.5v7.8c0,1.9-1.6,3.5-3.5,3.5c0,0,0,0,0,0H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 28.17,
    x2: 15.62,
    y2: 28.17,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.7,20.9c1.7,0,3,1.4,3,3.1v7.8c0,1.7-1.3,3-3,3.1H4c-1.7,0-3-1.4-3-3.1v-7.8c0-1.7,1.3-3,3-3.1H11.7  M11.7,19.9H4c-2.2,0-4,1.8-4,4v7.8c0,2.2,1.8,4,4,4h7.7c2.2,0,4-1.8,3.9-4v-7.8C15.7,21.7,14,19.9,11.7,19.9L11.7,19.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,54.5c-1.9,0-3.5-1.5-3.5-3.5c0,0,0,0,0-0.1v-7.8c0-1.9,1.6-3.5,3.5-3.5c0,0,0,0,0,0h7.7 c1.9,0,3.5,1.6,3.5,3.5V51c0,1.9-1.6,3.5-3.5,3.5c0,0,0,0,0,0H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 8.905,
    x2: 15.62,
    y2: 8.905,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.7,40.1c1.7,0,3,1.3,3,3c0,0,0,0,0,0.1V51c0,1.7-1.3,3-3,3.1H4c-1.7,0-3.1-1.3-3.1-3c0,0,0,0,0,0v-7.8 c0-1.7,1.3-3,2.9-3.1c0,0,0,0,0.1,0L11.7,40.1 M11.6,39.2H4c-2.2,0-4,1.8-4,4V51c0,2.2,1.8,4,4,4l0,0h7.7c2.2,0,4-1.8,3.9-4v-7.8 c0-2.2-1.8-4-3.9-4L11.6,39.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.47,
    y1: 47.445,
    x2: 55,
    y2: 47.445,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 7.1,
    className: "st4",
    width: 35.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.47,
    y1: 28.175,
    x2: 55,
    y2: 28.175,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 26.4,
    className: "st5",
    width: 35.5,
    height: 2.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.47,
    y1: 8.905,
    x2: 55,
    y2: 8.905,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 45.7,
    className: "st6",
    width: 35.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.716,
    y1: 49.425,
    x2: 16.476,
    y2: 49.425,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M7.4,13.1c-0.6,0-1.1-0.3-1.3-0.8L3.9,8.4C3.7,8,3.7,7.6,3.8,7.2c0.1-0.4,0.4-0.8,0.7-1C4.7,6.1,5,6,5.3,6 c0.1,0,0.3,0,0.4,0.1c0.4,0.1,0.7,0.4,0.9,0.7l0.9,1.6V8.3c1.9-2.8,4-5.4,6.3-7.9C14.1,0.2,14.5,0,14.9,0l0,0 c0.4,0,0.8,0.2,1.1,0.5c0.6,0.6,0.6,1.6,0,2.2c-2.8,2.9-5.3,6.2-7.3,9.7C8.4,12.9,7.9,13.2,7.4,13.1L7.4,13.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.716,
    y1: 30.15,
    x2: 16.476,
    y2: 30.15,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.4,32.4c-0.6,0-1.1-0.3-1.3-0.8l-2.1-3.9c-0.2-0.4-0.2-0.8-0.2-1.2c0.1-0.4,0.4-0.8,0.7-1 c0.2-0.1,0.5-0.2,0.8-0.2c0.1,0,0.3,0,0.4,0.1c0.4,0.1,0.7,0.4,0.9,0.7l0.9,1.6v-0.1c1.8-2.8,3.9-5.5,6.3-7.9 c0.3-0.3,0.7-0.5,1.1-0.5l0,0c0.4,0,0.8,0.2,1.1,0.5c0.6,0.6,0.7,1.6,0.1,2.3c0,0,0,0,0,0c-2.8,2.9-5.3,6.2-7.3,9.7 C8.4,32.2,7.9,32.5,7.4,32.4L7.4,32.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.7159,
    y1: 10.89,
    x2: 16.4759,
    y2: 10.89,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C2057"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17243E"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.4,51.7c-0.6,0-1.1-0.3-1.3-0.8l-2.1-4c-0.2-0.4-0.2-0.8-0.2-1.2c0.1-0.4,0.4-0.8,0.7-1 c0.2-0.1,0.5-0.2,0.8-0.2c0.1,0,0.3,0,0.4,0.1c0.4,0.1,0.7,0.4,0.9,0.7L7.5,47v-0.1c1.8-2.8,4-5.5,6.3-7.9 c0.3-0.3,0.7-0.5,1.1-0.5l0,0c0.4,0,0.8,0.2,1.1,0.5c0.6,0.6,0.6,1.6,0,2.2c-2.8,2.9-5.3,6.2-7.3,9.7C8.4,51.4,7.9,51.7,7.4,51.7 L7.4,51.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConseil1PageParcoursupCoach);
export default __webpack_public_path__ + "static/media/conseil-1-page-parcoursup-coach.65d2148c5b5100400f8b5bce4e1e46e9.svg";
export { ForwardRef as ReactComponent };